import { render, staticRenderFns } from "./jono-and-raj.vue?vue&type=template&id=2dac0586&"
import script from "./jono-and-raj.vue?vue&type=script&lang=js&"
export * from "./jono-and-raj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports